import React from 'react';
import axios from 'axios';
import bdApi from '../Api/BankDataApi';
import Notifications from 'react-notification-system-redux';
import * as constants from './types';

export function clearXPAState() {
  return { type: constants.CLEAR_XPA_STATE };
}

export function showError(message) {
  return Notifications.warning({ message });
}

const handleAuthError = (status, dispatch, errorMessage = undefined) => {
  const cognitotoken = localStorage.getItem('cognitotoken');
  let error = false;

  if (cognitotoken) {
    if (status === 400 || status === 401 || status === 403) {
      dispatch({ type: constants.REQUEST_FAILURE });
      error = true;
    }
  } else {
    if (status === 401) {
      dispatch({ type: constants.REQUEST_FAILURE, payload: errorMessage || 'Your token is invalid / expired, please try again.' });
      error = true;
    }
    if (status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('bookid');
      dispatch({ type: constants.REQUEST_FAILURE });
      error = true;
    }
  }
  return error;
};

export function getBankFeeds(bookId) {
  return function(dispatch) {
    bdApi
      .get(`bankfeed/${bookId}`)
      .then((response) => {
       // const feeds = response.data.feeds.filter((item) => item.status !== 'Deleted');
        dispatch({ type: constants.GET_FEEDS, feeds: response.data.feeds, userid: response.data.userId });
      })
      .catch((error) => {
        if (process.env.BANKDATA_ENV === 'production') {
          dispatch(Notifications.warning({ message: 'Could not fetch bank feeds' }));
        } else {
          if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
          const resolved = handleAuthError(error.response.status, dispatch);
          if (!resolved) {
            const errorMsg = ` GET: ${constants.ROOT_URL}/bankfeed/${bookId} -- Response: ${
              error.response ? error.response.data.message : error.toString()
            } ${
              error.response &&
              error.response.data &&
              error.response.data.message &&
              error.response.data.message.includes('token validation')
                ? `------------ Header ------------ ${JSON.stringify(error.response.config.headers)}`
                : ''
            }`;
            dispatch({ type: constants.SET_ERROR, payload: errorMsg });
          }
        }
      });
  };
}

// export const getBankFeeds = (bookId) => async dispatch => {
//   const cognitotoken = localStorage.getItem("cognitotoken");
//   const headers = cognitotoken ? { cognitotoken: localStorage.getItem("cognitotoken") } : { authorizationtoken: localStorage.getItem("token") };

//   try {
//     const response = await axios.get(`${ROOT_URL}/bankfeed/${bookId}`, { headers })
//     const payload = response.data.feeds.filter(item => item.status !== 'Deleted')

//     dispatch({ type: GET_FEEDS, payload });
//   } catch (error) {
//     if (process.env.BANKDATA_ENV === 'production') {
//       dispatch(Notifications.warning({ message: 'Could not fetch bank feeds' }));
//     } else {
//       const errorMsg = ` GET: ${ROOT_URL}/bankfeed/${bookId} -- Response: ${(error.response) ? error.response.data.message : error.toString()} ${(error.response && error.response.data && error.response.data.message && error.response.data.message.includes('token validation') ? `------------ Header ------------ ${JSON.stringify(error.response.config.headers)}` : '')}`;
//       dispatch({ type: SET_ERROR, payload: errorMsg });
//     }
//   }
// }

export function addBankFeed(feedDetails, showDownload) {
  return function(dispatch) {
    const bookId = localStorage.getItem('bookid');

    bdApi
      .post(`bankfeed/${bookId}/`, feedDetails)
      .then(() => bdApi.get(`bankfeed/${bookId}`))
      .then((response) => {
        const message = { message: 'Added Bank Feed' };
        // If CBA feed
        if (feedDetails.bankId === 4) {
          message.title = 'Added Bank Feed';
          message.message = <div>CBA is very specific with how the<br /> Authorisation form should be completed.<br />Please read this guide on completing the<br />form.</div>;
          message.autoDismiss = 0;
          message.action = {
            label: 'Authorisation Form Guide',
            callback: () => window.open(constants.CBA_FORM_HELP, '_blank')
          }
        }
        dispatch(Notifications.success(message));
        dispatch({ type: constants.GET_FEEDS, feeds: response.data.feeds });
        showDownload(feedDetails);
      })
      .catch((error) => {
        if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
        const resolved = handleAuthError(error.response.status, dispatch);
        if (!resolved) {
          const { data } = error.response;
          if (data && data.message) {
            const message = data.message.includes('"') ? data.message.split('"')[1] : data.message;
            dispatch(Notifications.warning({ message, autoDismiss: 0 }));
          } else {
            dispatch(Notifications.warning({ message: 'Could not add bank feed' }));
          }

          if (process.env.BANKDATA_ENV !== 'production') {
            const errorMsg = `POST: ${constants.ROOT_URL}/bankfeed/${bookId} -- Response: ${
              error.response ? data.message : error.toString()
            }`;
            dispatch({ type: constants.SET_ERROR, payload: errorMsg });
          }
        }
      });
  };
}

export function addLedger(ledger, history) {
  return function(dispatch) {
    dispatch(Notifications.info({ title: 'Creating Feed Collection', autoDismiss: 0 }));
    bdApi
      .post('XPA/ledger', ledger)
      .then((response) => {
        localStorage.setItem('bookid', response.data.body.bookId);
        dispatch(Notifications.removeAll());
        dispatch(Notifications.success({ title: 'Feed Collection Created ...' }));
        history.push(`/xpa?BookID=${response.data.body.bookId}&cognitotoken=${localStorage.getItem('cognitotoken')}`);
      })
      .catch((error) => {
        if (process.env.BANKDATA_ENV === 'production') {
          dispatch(Notifications.warning({ message: 'A Feed Collection with that name already exists' }));
        } else {
          const errorMsg = `POST: ${constants.ROOT_URL}/XPA/ledger -- Response: ${
            error.response ? 'A Feed Collection with that name already exists' : error.toString()
          }`;
          dispatch({ type: constants.SET_ERROR, payload: errorMsg });
        }
      });
  };
}

export function deleteBankFeed(feedId, yodleeAccountId, feeds) {
  const bookid = localStorage.getItem('bookid');
  const isR1 = !(localStorage.getItem('cognitotoken') || localStorage.getItem('authtype') === 'RAH');
  const bankAccountUrl = isR1 ? `R1/${bookid}/bankaccounts/` : `RAH/${bookid}/bankaccounts/`;
  return function(dispatch) {
    bdApi
      .delete(`bankfeed/${feedId}${yodleeAccountId ? `/${yodleeAccountId}` : ''}`)
      .then(() => {
        const payload = feeds.map((feed) => (yodleeAccountId ? feed.YodleeItemAccountID !== yodleeAccountId : feed.feedId !== feedId)
          ? feed
          : ({ ...feed, status: 'Deleted' }));
        dispatch({ type: constants.GET_FEEDS, feeds: payload });
        return bdApi.get(bankAccountUrl);
      })
      .then((response) => {
        const payload = isR1 ? response.data.bankAccounts.filter((item) => item.isCash === false) : response.data.bankAccounts;
        dispatch({ type: constants.GET_MAP_BANKS, payload });
      })
      .catch((error) => {
        try {
          const isHandled = handleAuthError(error.response.status, dispatch);
          if (!isHandled) {
            const errorMsg = error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : 'Unable to delete the feed';
            dispatch(showError(errorMsg));
            if (process.env.BANKDATA_ENV !== 'production') {
              const message = error.response.data && error.response.data.message ? error.response.data.message.message : error.response.data;
              const errorMsg = `DELETE: ${constants.ROOT_URL}/bankfeed/${feedId} -- Response: ${message}`;
              dispatch({ type: constants.SET_ERROR, payload: errorMsg });
            }
          }
        } catch (error) {
          dispatch(showError('Unable to process the request.'));
        }
      });
  };
}

export function linkBankFeed(feed) {
  const bookid = localStorage.getItem('bookid');
  const isR1 = !(localStorage.getItem('cognitotoken') || localStorage.getItem('authtype') === 'RAH');
  const bankAccountUrl = isR1 ? `R1/${bookid}/bankaccounts/` : `RAH/${bookid}/bankaccounts/`;
  return function(dispatch) {
    bdApi
      .patch(
        `books/${bookid}/bankaccounts/${feed.bankAccountId}`,
        isR1
          ? { ClientAccountId: feed.clientAccountId, R1BankAccountId: feed.R1BankAccountId, oldBankAccountId: feed.oldR1BankAccountId }
          : { RAHBankAccountId: feed.RAHBankAccountId }
      )
      .then(() => {})
      .then(() => bdApi.get(bankAccountUrl))
      .then((response) => {
        const bankAccounts = response.data.bankAccounts;
        const payload = { bankAccounts, feed };
        dispatch({ type: constants.LINK_FEED, payload });
      })
      .catch((error) => {
        if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
        const errorMsg = error.response.data && error.response.data.message ? error.response.data.message : undefined;
        handleAuthError(error.response.status, dispatch, errorMsg);
      });
  };
}

export function linkExistingFeed(feeds) {
  const bookid = localStorage.getItem('bookid');
  return function(dispatch) {
    let requestList = [];
    feeds.forEach((feed) => {
      const { feedId, clientAccountId, yodleeItemAccountId } = feed;
      requestList.push(bdApi.post(`bankfeed/relink/${bookid}`, { feedId, clientAccountId, yodleeItemAccountId }));
    });
    axios
      .all(requestList)
      .then(() => {
        dispatch(Notifications.success({ message: 'Linked Bank Feed' }));
      })
      .catch((error) => {
        const resolved = handleAuthError(error.response.status, dispatch);
        if (!resolved) {
          let message = error.response.data && error.response.data.message ? error.response.data.message : error.response.data;
          if (process.env.BANKDATA_ENV === 'production') {
            dispatch(Notifications.warning({ message }));
          } else {
            const errorMsg = `POST: ${constants.ROOT_URL}/bankfeed/relink/${bookid} -- Response: ${message}`;
            dispatch({ type: constants.SET_ERROR, payload: errorMsg });
          }
        }
      })
      .finally(() => {
        bdApi.get(`bankfeed/${bookid}`).then((response) => {
          dispatch({ type: constants.GET_FEEDS, feeds: response.data.feeds });
        });
      });
  };
}

export function unlinkBankFeed(feed) {
  const bookid = localStorage.getItem('bookid');
  const isR1 = !(localStorage.getItem('cognitotoken') || localStorage.getItem('authtype') === 'RAH');
  const bankAccountUrl = isR1 ? `R1/${bookid}/bankaccounts/` : `RAH/${bookid}/bankaccounts/`;
  const body = { feedId: feed.feedId, yodleeItemAccountId: feed.YodleeItemAccountID };
  return function(dispatch) {
    bdApi
      .post(`bankfeed/unlink/${bookid}`, body)
      .then(() => {
        dispatch(Notifications.success({ message: 'Bank Feed Unlinked' }));
        bdApi
          .get(`bankfeed/${bookid}`)
          .then((response) => {
            dispatch({ type: constants.GET_FEEDS, feeds: response.data.feeds });
            return bdApi.get(bankAccountUrl);
          })
          .then((response) => {
            const payload = isR1 ? response.data.bankAccounts.filter((item) => item.isCash === false) : response.data.bankAccounts;
            dispatch({ type: constants.GET_MAP_BANKS, payload });
          });
      })
      .catch((error) => {
        const resolved = handleAuthError(error.response.status, dispatch);
        if (!resolved) {
          let message = error.response.data && error.response.data.message ? error.response.data.message : error.response.data;
          if (process.env.BANKDATA_ENV === 'production') {
            dispatch(Notifications.warning({ message }));
          } else {
            const errorMsg = `POST: ${constants.ROOT_URL}/bankfeed/unlink/${bookid} -- Response: ${message}`;
            dispatch({ type: constants.SET_ERROR, payload: errorMsg });
          }
        }
      });
  };
}

export function editBankFeedName(edit) {
  return { type: constants.TOGGLE_FIELD, payload: edit };
}

export function changeBankFeedName(feed) {
  const bookid = localStorage.getItem('bookid');
  return function(dispatch) {
    dispatch({ type: constants.REQUEST_UPDATE_FEED_ACCOUNTNAME });
    bdApi
      .patch(`books/${bookid}/bankaccounts/${feed.bankAccountId}`, { AccountName: feed.accountName })
      .then(() => {
        const payload = feed;
        dispatch({ type: constants.UPDATE_FEED_ACCOUNTNAME_SUCCESS, payload });
      })
      .catch((error) => {
        if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
        const resolved = handleAuthError(error.response.status, dispatch);
        if (!resolved) dispatch({ type: constants.UPDATE_FEED_ACCOUNTNAME_FAILURE, payload: 'Request failed, please try again.' });
      });
  };
}

export function getR1BankAccounts() {
  return function(dispatch) {
    bdApi
      .get(`R1/${localStorage.getItem('bookid')}/bankaccounts/`)
      .then((response) => {
        const payload = response.data.bankAccounts.filter((item) => item.isCash === false);
        dispatch({ type: constants.GET_MAP_BANKS, payload });
      })
      .catch((error) => {
        if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
        handleAuthError(error.response.status, dispatch);
      });
  };
}

export function getRAHBankAccounts() {
  return function(dispatch) {
    bdApi
      .get(`RAH/${localStorage.getItem('bookid')}/bankaccounts/`)
      .then((response) => {
        const payload = response.data.bankAccounts;
        dispatch({ type: constants.GET_RAH_BANKACCOUNTS, payload });
      })
      .catch((error) => {
        if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: 'Unable to process the request.' });
        handleAuthError(error.response.status, dispatch);
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/xpa.js